<template>
    <div v-if="isImpersonating" class="flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-white">
        <font-awesome-icon :icon="['fa', 'user-secret']" class="w-4 h-4"/>
        <span>Vous êtes connecté en tant que {{ user.name }}</span>
        <button class="underline hover:no-underline" @click="stopImpersonating">
            Revenir à mon compte
        </button>
    </div>
</template>

<script>
export default {
    computed: {
        isImpersonating() {
            return this.$store.state.auth.impersonationOrigin !== null;
        },
        user() {
            return this.$store.state.auth.user;
        }
    },
    methods: {
        stopImpersonating() {
            this.$store.dispatch('auth/stopImpersonating');
        }
    }
};
</script>
